<template lang="html">

      <section class="noticia-fake">

        <article class="container">

          <div class="img-full -backgroundLoad"></div>

          <h1 class="title -backgroundLoad"></h1>  

          <p class="fecha -backgroundLoad"></p> 

          <div class="parrafos">
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
            <p class="-backgroundLoad"></p>
          </div>


        </article>

      </section>

</template>

<script lang="js">
  export default  {
    name: 'ficha-fake',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
.noticia-fake{
  margin-top: 100px;
  display: inline-block;
  width: 100%;
}

.noticia-fake .container{
  width: 100%;
  padding-left: 150px;
  text-align: left;
}

.noticia-fake .title{
  height: 40px;
  display: inline-block;
  width: 100%;
  max-width: 460px;
  margin-bottom: 10px;
}

.noticia-fake p{
  height: 20px;
  width: 100%;
  display: block;
  margin-bottom: 10px;
  max-width: 768px;
}

.noticia-fake p.fecha{
  max-width: 200px;
}

.noticia-fake .parrafos{
  margin-top: 40px;
  margin-bottom: 60px;
  padding-left: 50px;
}


.noticia-fake .img-full{
  width: 100%;
  max-height: 500px;
  height: 100vw;
  display: inline-block;
}

.-backgroundLoad{
  -webkit-animation: GrisAnimation 2s ease infinite;
  -moz-animation: GrisAnimation 2s ease infinite;
  animation: GrisAnimation 2s ease infinite;
  background: linear-gradient(274deg, #f9f8f2, #eae7d8);
  background-size: 400% 400%;
}

@keyframes GrisAnimation { 
  0%{background-position:0% 48%}
  50%{background-position:100% 53%}
  100%{background-position:0% 48%}
}
</style>



// WEBPACK FOOTER //
// src/components/view-parts/actualidad/ficha-fake.vue